import { Button, Col, Input, Layout, message, Row, Typography } from 'antd';
import React from 'react';
import { IoArrowUndo, IoMailOpen } from 'react-icons/io5';
import { Link, Navigate } from 'react-router-dom';
import { POST_API, POST_CATCH } from '../../services/api';

class AuthForgot extends React.Component {
  state = {
    _navigate: false,
    load: false,
    side: 0,
    doc: false,
    form: {
      email: '',
    },
  };

  onChangeValue = (field, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [field]: value,
      },
    });
  };

  onSend = async () => {
    const { email } = this.state.form;
    if (email === '') {
      message.warning('Por favor, preencha todos os campos');
    } else {
      this.setState({ load: true });
      const values = {
        EMAIL: email,
      };

      await POST_API('/credential/forgot.php', {
        token: 'X',
        master: JSON.stringify(values),
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            message.success(res.msg);
            this.setState({ _navigate: true });
          } else {
            message.warning(res.msg);
          }
        })
        .catch(() => {
          POST_CATCH();
        })
        .finally(() => {
          this.setState({ load: false });
        });
    }
  };

  render = () => {
    if (this.state._navigate) {
      return <Navigate to="/login" />;
    }

    return (
      <Layout.Content className="web-body">
        <Layout.Content className="auth-content">
          <Row className="auth-box-login">
            <Col className={'auth-col active all'}>
              <Link to="/login">
                <Button
                  className="btn-primary btn-auth"
                  shape="circle"
                  type="primary"
                >
                  <IoArrowUndo size={22} />
                </Button>
              </Link>
              <Typography className="auth-col-title">
                Esqueceu a senha?
              </Typography>
              <Typography
                className="auth-col-text color-white"
                style={{ marginTop: 10 }}
              >
                Preencha seu e-mail que enviaremos uma nova senha para você
              </Typography>
              <Input
                className="auth-input"
                defaultValue={this.state.form.email}
                onChange={(v) => this.onChangeValue('email', v.target.value)}
                placeholder="E-mail"
                prefix={<IoMailOpen />}
                size="large"
              />
              <div className="plan-card-button">
                <Button
                  className="btn-outline"
                  loading={this.state.load}
                  onClick={this.onSend}
                  shape="round"
                  type="default"
                >
                  ENVIAR E-MAIL
                </Button>
              </div>
            </Col>
          </Row>
        </Layout.Content>
      </Layout.Content>
    );
  };
}

export default AuthForgot;
